export default {"src":"/_next/static/media/connect.310bc163.svg","height":32,"width":33};